import { Component, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { AppService } from '../_shared/services/app.service';
import { environment } from '../../environments/environment';
import { PermissionService } from '../_shared/services/permission.service';

@Component({
    selector: 'app-next-steps',
    templateUrl: './next-steps.component.html',
    styleUrls: ['./next-steps.component.scss'],
    standalone: false
})
export class NextStepsComponent implements OnInit {
    constructor(
        private activatedRoute: ActivatedRoute,
        matIconRegistry: MatIconRegistry,
        domSanitizer: DomSanitizer,
        public appService: AppService,
        private permissionService: PermissionService
    ) {
        matIconRegistry.addSvgIcon(
            'piggy-bank',
            domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/piggy-bank.svg')
        );
        matIconRegistry.addSvgIcon(
            'coin-stack',
            domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/coin-stack.svg')
        );
    }

    public sapDocumentId: string;
    public quoteId: string;
    public externalApp: boolean;
    public callbackUrl: string;
    public serviceConfiguratorUrl: string;
    public viOfferUrl: string;

    public ngOnInit() {
        const { id, sapDocumentId, externalApp, callbackUrl } = this.activatedRoute.snapshot.queryParams;
        this.quoteId = id;
        this.sapDocumentId = sapDocumentId;
        this.externalApp = externalApp === 'true';
        this.serviceConfiguratorUrl = `${environment.http.serviceConfiguratorBaseUrl}/configuration/new?offerNumber=${this.sapDocumentId}`;
        if (this.permissionService.isUserAnEmployee) {
            this.viOfferUrl = this.appService.getViOfferUrl(sapDocumentId);
        }
        this.callbackUrl = callbackUrl;
    }
}
